import "./Footer.css";

const Footer = () => {
  return (
    <div className="footer-kapsayici">
      <div className="footer-div">
        <div className="brand">
          {"<Dogukan />"}
          <span> &#169; copyright 2022</span>
        </div>
      </div>
    </div>
  );
};

export default Footer;
